export function sanitizeValueToI18nKey(key) {
    if (!key) {
        return '';
    }
    return (key
        // 1. Separate accents from letters (é -> e + ´)
        .normalize('NFD')
        // 2. Remove the accent marks
        .replace(/[\u0300-\u036f]/g, '')
        // 3. REPLACE: turn symbols/spaces into underscores
        .replace(/[^a-zA-Z0-9]+/g, '_')
        // 4. Clean up case
        .toLowerCase());
}
//# sourceMappingURL=i18n.utils.js.map